import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  justify-content: flex-start;
  position: relative;
`;

export const InputError = styled.p`
  text-align: right;
  font-size: 0.88rem;
  color: #ff2e3e;
  position: absolute;
  bottom: -1.44rem;
  left: 5px;
`;
